<div class="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6">

  <!-- Header Section -->
  <div class="mb-8">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div>
        <h1 class="text-3xl font-bold text-gray-900 mb-2">Progress Reports</h1>
        <p class="text-gray-600">
          Record daily chainage progress and geotagged site media
        </p>
      </div>

      <div class="flex flex-wrap gap-4">
        <div class="bg-white rounded-lg px-4 py-3 shadow-sm border border-gray-200">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
              <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
              </svg>
            </div>
            <div>
              <p class="text-sm text-gray-600">Reports</p>
              <p class="text-lg font-semibold text-gray-900">{{ dataSource.data.length }}</p>
            </div>
          </div>
        </div>
        <div class="bg-white rounded-lg px-4 py-3 shadow-sm border border-gray-200">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center">
              <svg class="w-5 h-5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"></path>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"></path>
              </svg>
            </div>
            <div>
              <p class="text-sm text-gray-600">Media</p>
              <p class="text-lg font-semibold text-gray-900">{{ media.length }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Search and Filter Section -->
  <div class="bg-white rounded-2xl shadow-lg border border-gray-200 p-6 mb-8">
    <div class="flex flex-col lg:flex-row gap-4 items-stretch lg:items-center">
      <div class="flex-1">
        <div class="relative">
          <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </div>
          <input
            type="text"
            placeholder="Search report"
            class="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-xl leading-5 bg-gray-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all duration-200"
            (input)="applyFilter($event)"
          />
        </div>
      </div>

      <div class="lg:w-64">
        <select
          class="w-full px-4 py-3 border border-gray-300 rounded-xl bg-gray-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all duration-200 text-gray-700"
          [(ngModel)]="projectId"
          name="pid"
          (change)="onProject()"
        >
          <option [ngValue]="null">All projects</option>
          <option *ngFor="let p of projects" [ngValue]="p.id">{{ p.project_name || p.project_identifier || p.id }}</option>
        </select>
      </div>

      <button
        routerLink="/home/add-progress-report"
        class="inline-flex items-center justify-center px-6 py-3 border border-transparent text-sm font-medium rounded-xl text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 transform hover:scale-105 active:scale-95 shadow-lg whitespace-nowrap"
      >
        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
        </svg>
        Add Progress Report
      </button>
    </div>
  </div>

  <!-- Record chainage DPR -->
  <div class="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden mb-8">
    <div class="px-6 py-4 border-b border-gray-200 bg-gray-50">
      <h2 class="text-lg font-semibold text-gray-900">Record chainage DPR</h2>
      <p class="text-sm text-gray-600 mt-1">Log daily quantity against location and pavement layer</p>
    </div>

    <div class="p-6">
      <form class="grid grid-cols-1 md:grid-cols-5 gap-4 items-end mb-6" (ngSubmit)="submit()">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Location</label>
          <select
            class="w-full px-4 py-3 border border-gray-300 rounded-xl bg-gray-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all duration-200 text-gray-700"
            [(ngModel)]="form.work_location_id"
            name="wl"
          >
            <option value="">Select location</option>
            <option *ngFor="let l of locations" [ngValue]="l.id">{{ l.location_name || l.id }}</option>
          </select>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Pavement layer</label>
          <select
            class="w-full px-4 py-3 border border-gray-300 rounded-xl bg-gray-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all duration-200 text-gray-700"
            [(ngModel)]="form.pavement_work_item_id"
            name="wi"
          >
            <option value="">Select layer</option>
            <option *ngFor="let w of workItems" [ngValue]="w.id">{{ w.layer_label }} &#64; {{ w.location_name }}</option>
          </select>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Qty <span class="text-red-500">*</span></label>
          <input
            type="number"
            required
            class="w-full px-4 py-3 border border-gray-300 rounded-xl bg-gray-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all duration-200 text-gray-700"
            [(ngModel)]="form.qty"
            name="qty"
            placeholder="Quantity"
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Remarks</label>
          <input
            type="text"
            class="w-full px-4 py-3 border border-gray-300 rounded-xl bg-gray-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all duration-200 text-gray-700"
            [(ngModel)]="form.remarks"
            name="rm"
            placeholder="Optional remarks"
          />
        </div>
        <button
          type="submit"
          class="inline-flex items-center justify-center px-6 py-3 border border-transparent text-sm font-medium rounded-xl text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 shadow-lg h-[50px]"
        >
          Save DPR
        </button>
      </form>

      <div class="overflow-x-auto -mx-6">
        <table mat-table [dataSource]="dataSource" matSort class="w-full">
          <ng-container matColumnDef="reportDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
              Report Date
            </th>
            <td mat-cell *matCellDef="let report" class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ report.reportDate | date }}
            </td>
          </ng-container>
          <ng-container matColumnDef="organization">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
              Organization
            </th>
            <td mat-cell *matCellDef="let report" class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ report.organization || '—' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="workDescription">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
              Work Description
            </th>
            <td mat-cell *matCellDef="let report" class="px-6 py-4 text-sm text-gray-900">
              {{ report.workDescription }}
            </td>
          </ng-container>
          <ng-container matColumnDef="progressPercentage">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
              Qty
            </th>
            <td mat-cell *matCellDef="let report" class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ report.progressPercentage }}
            </td>
          </ng-container>
          <ng-container matColumnDef="qualityPassed">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
              Quality
            </th>
            <td mat-cell *matCellDef="let report" class="px-6 py-4 whitespace-nowrap text-sm">
              <span
                class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium"
                [ngClass]="report.qualityPassed ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'"
              >
                {{ report.qualityPassed ? 'Yes' : 'No' }}
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="inspectionDone">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
              Layer linked
            </th>
            <td mat-cell *matCellDef="let report" class="px-6 py-4 whitespace-nowrap text-sm">
              <span
                class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium"
                [ngClass]="report.inspectionDone ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-600'"
              >
                {{ report.inspectionDone ? 'Yes' : 'No' }}
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="photo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
              UOM
            </th>
            <td mat-cell *matCellDef="let report" class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ report.photo || '—' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
              Actions
            </th>
            <td mat-cell *matCellDef="let report" class="px-6 py-4 whitespace-nowrap text-sm font-medium">
              <button
                [routerLink]="['/home/add-progress-report']"
                class="inline-flex items-center p-2 border border-transparent rounded-lg text-blue-600 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200"
                matTooltip="Edit"
                matTooltipPosition="above"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                </svg>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
          <tr mat-row *matRowDef="let row; columns: columnsToDisplay;" class="hover:bg-gray-50 transition-colors"></tr>
        </table>
      </div>

      <p *ngIf="dataSource.data.length < 1" class="text-center text-gray-400 py-8">No progress reports yet.</p>
      <div class="border-t border-gray-200 pt-2 mt-2">
        <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
      </div>
    </div>
  </div>

  <!-- Geotagged photos -->
  <div class="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
    <div class="px-6 py-4 border-b border-gray-200 bg-gray-50">
      <h2 class="text-lg font-semibold text-gray-900">Geotagged photos</h2>
      <p class="text-sm text-gray-600 mt-1">Attach site media with GPS coordinates</p>
    </div>

    <div class="p-6">
      <form class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-4 items-end mb-6" (ngSubmit)="addMedia()">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Location</label>
          <select
            class="w-full px-4 py-3 border border-gray-300 rounded-xl bg-gray-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all duration-200 text-gray-700"
            [(ngModel)]="mediaForm.work_location_id"
            name="mwl"
          >
            <option value="">Select location</option>
            <option *ngFor="let l of locations" [ngValue]="l.id">{{ l.location_name || l.id }}</option>
          </select>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Caption</label>
          <input
            type="text"
            class="w-full px-4 py-3 border border-gray-300 rounded-xl bg-gray-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all duration-200 text-gray-700"
            [(ngModel)]="mediaForm.caption"
            name="cap"
            placeholder="Photo caption"
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Latitude</label>
          <input
            type="number"
            class="w-full px-4 py-3 border border-gray-300 rounded-xl bg-gray-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all duration-200 text-gray-700"
            [(ngModel)]="mediaForm.latitude"
            name="mlat"
            placeholder="Lat"
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Longitude</label>
          <input
            type="number"
            class="w-full px-4 py-3 border border-gray-300 rounded-xl bg-gray-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all duration-200 text-gray-700"
            [(ngModel)]="mediaForm.longitude"
            name="mlng"
            placeholder="Lng"
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">File URL / S3 key</label>
          <input
            type="text"
            class="w-full px-4 py-3 border border-gray-300 rounded-xl bg-gray-50 focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none transition-all duration-200 text-gray-700"
            [(ngModel)]="mediaForm.file_url"
            name="murl"
            placeholder="s3://… or https://…"
          />
        </div>
        <button
          type="submit"
          class="inline-flex items-center justify-center px-6 py-3 border border-transparent text-sm font-medium rounded-xl text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 shadow-lg h-[50px]"
        >
          Save media
        </button>
      </form>

      <div class="overflow-x-auto -mx-6" *ngIf="media.length">
        <table mat-table [dataSource]="media" class="w-full">
          <ng-container matColumnDef="cap">
            <th mat-header-cell *matHeaderCellDef class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
              Caption
            </th>
            <td mat-cell *matCellDef="let row" class="px-6 py-4 text-sm text-gray-900">
              {{ row.caption || row.file_url || row.s3_key }}
            </td>
          </ng-container>
          <ng-container matColumnDef="geo">
            <th mat-header-cell *matHeaderCellDef class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">
              GPS
            </th>
            <td mat-cell *matCellDef="let row" class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ row.geometry?.coordinates?.join(', ') || '—' }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['cap','geo']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['cap','geo']" class="hover:bg-gray-50 transition-colors"></tr>
        </table>
      </div>
      <p *ngIf="!media.length" class="text-center text-gray-400 py-8">No geotagged media yet.</p>
    </div>
  </div>
</div>
